import React from "react";
import { Button } from "./Button";

type Props = {
    actionable: boolean;
}
export const CalculateButton = ({actionable}:Props) => (<Button actionable={actionable} text="Calculate" />);